/* Kiosk-hulpjes: geluid, trilling, offline-wachtrij, wake lock. */
let ctx = null;
const tone = (freq, ms, type = "sine", when = 0) => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.type = type; o.frequency.value = freq; o.connect(g); g.connect(ctx.destination);
    const t = ctx.currentTime + when; g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.4, t + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t + ms / 1000);
    o.start(t); o.stop(t + ms / 1000 + 0.05);
  } catch (err) { console.debug("audio unavailable", err); }
};
export const beep = {
  ok: () => { tone(880, 120); tone(1320, 160, "sine", 0.13); navigator.vibrate?.(80); },
  out: () => { tone(660, 120); tone(440, 200, "sine", 0.13); navigator.vibrate?.([60, 40, 60]); },
  err: () => { tone(220, 320, "square"); navigator.vibrate?.([120, 60, 120]); },
  key: () => { tone(1000, 25, "triangle"); navigator.vibrate?.(10); },
};

const QKEY = "gf_kiosk_queue";
export const queue = {
  all: () => { try { return JSON.parse(localStorage.getItem(QKEY) || "[]"); } catch { return []; } },
  push: (body) => { const q = queue.all(); const item = { ...body, at: new Date().toISOString(), offline_id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}` }; q.push(item); localStorage.setItem(QKEY, JSON.stringify(q)); return item; },
  remove: (id) => localStorage.setItem(QKEY, JSON.stringify(queue.all().filter((x) => x.offline_id !== id))),
};

export async function flushQueue(http) {
  let sent = 0;
  for (const item of queue.all()) {
    try { await http.post("/kiosk/punch", item); queue.remove(item.offline_id); sent++; }
    catch (e) { if (e?.response?.status && e.response.status < 500 && e.response.status !== 429) queue.remove(item.offline_id); else break; }
  }
  return sent;
}

export async function keepAwake() {
  try { const lock = await navigator.wakeLock?.request("screen"); document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") navigator.wakeLock?.request("screen").catch(() => {}); }); return lock; }
  catch (err) { console.debug("wakeLock unavailable", err); return null; }
}
